// agents/src/pages/Settings.jsx
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/LanguageSwitcher';
import NotificationSettings from '../components/NotificationSettings';

export default function Settings() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showNotificationSettings, setShowNotificationSettings] = useState(false);

  return (
    <div style={styles.mainContent}>
        <div style={styles.header}>
          <h1 style={styles.title}>{t('settings.title', 'Ajustes')}</h1>
        </div>

        <div style={styles.contentScroll}>
          {/* Sección: Idioma */}
          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>{t('settings.language', 'Idioma')}</h2>
            <div style={styles.sectionContent}>
              <LanguageSwitcher />
            </div>
          </div>

          {/* Sección: Notificaciones */}
          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>{t('settings.notifications', 'Notificaciones')}</h2>
            <div style={styles.sectionContent}>
              <button
                onClick={() => setShowNotificationSettings(!showNotificationSettings)}
                style={styles.settingsButton}
              >
                {showNotificationSettings ? '🔕 Ocultar configuración' : '🔔 Configurar notificaciones'}
              </button>
            </div>
          </div>

          {/* Sección: Perfil */}
          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>{t('settings.profile', 'Perfil')}</h2>
            <div style={styles.sectionContent}>
              <button
                onClick={() => navigate('/profile')}
                style={styles.settingsButton}
              >
                👤 Ver perfil
              </button>
            </div>
          </div>

          {/* Sección: Sesión */}
          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>{t('settings.session', 'Sesión')}</h2>
            <div style={styles.sectionContent}>
              <button
                onClick={() => {
                  localStorage.removeItem('token');
                  navigate('/login');
                }}
                style={{...styles.settingsButton, ...styles.logoutButton}}
              >
                🚪 Cerrar sesión
              </button>
            </div>
          </div>
        </div>

        {/* Modal de Notificaciones */}
      {showNotificationSettings && (
        <div style={styles.modalOverlay} onClick={() => setShowNotificationSettings(false)}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <h3>{t('settings.notifications', 'Notificaciones')}</h3>
              <button
                onClick={() => setShowNotificationSettings(false)}
                style={styles.closeButton}
              >
                ✕
              </button>
            </div>
            <NotificationSettings onClose={() => setShowNotificationSettings(false)}/>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  mainContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    background: '#fafafa',
  },
  header: {
    padding: '1.5rem 2rem',
    background: '#fff',
    borderBottom: '1px solid #e8e8e8',
  },
  title: {
    margin: 0,
    fontSize: '1.75rem',
    color: '#2c3e50',
    fontWeight: '600',
  },
  contentScroll: {
    flex: 1,
    overflowY: 'auto',
    padding: '2rem',
  },
  section: {
    background: '#fff',
    borderRadius: '8px',
    padding: '1.5rem',
    marginBottom: '1.5rem',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  },
  sectionTitle: {
    margin: '0 0 1rem 0',
    fontSize: '1.25rem',
    color: '#2c3e50',
    fontWeight: '500',
  },
  sectionContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  settingsButton: {
    padding: '0.75rem 1.5rem',
    background: '#423ef4',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: '500',
    transition: 'all 0.2s',
    textAlign: 'left',
  },
  logoutButton: {
    background: '#f5222d',
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000,
  },
  modalContent: {
    background: '#fff',
    borderRadius: '8px',
    padding: '2rem',
    maxWidth: '500px',
    width: '90%',
    maxHeight: '80vh',
    overflowY: 'auto',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1.5rem',
    paddingBottom: '1rem',
    borderBottom: '1px solid #e8e8e8',
  },
  closeButton: {
    background: 'none',
    border: 'none',
    fontSize: '1.5rem',
    cursor: 'pointer',
    color: '#999',
    padding: '0',
    width: '30px',
    height: '30px',
  },
};
